/**
 * App logo for browser notifications and in-app notification toasts.
 * Served from `public/ifindsLogo.png` → `/ifindsLogo.png`.
 */
export const NOTIFICATION_ICON_URL = '/ifindsLogo.png';
